/* holy-s3.js — chrome behavior: scroll-dock, right drawer, accordion, Studio side toggle. */
(function () {
  var root = document.documentElement;
  if (!root.getAttribute('data-side')) root.setAttribute('data-side', 'consumer');
  function onScroll() { root.classList.toggle('s3-scrolled', window.scrollY > 20); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  var drawer = document.getElementById('s3-drawer');
  var scrim = document.getElementById('s3-scrim');
  function openDrawer() { if (drawer) drawer.classList.add('s3-on'); if (scrim) scrim.classList.add('s3-on'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('s3-on'); if (scrim) scrim.classList.remove('s3-on'); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-s3-menu]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-s3-close]')) { e.preventDefault(); closeDrawer(); return; }
    var ex = t.closest('[data-s3-exp]'); if (ex) { e.preventDefault(); ex.parentNode.classList.toggle('s3-open'); return; }
    var st = t.closest('[data-s3-studio]'); if (st) { e.preventDefault(); root.setAttribute('data-side', root.getAttribute('data-side') === 'studio' ? 'consumer' : 'studio'); return; }
  });
})();
